import { render } from "./TaxStatus.vue?vue&type=template&id=22fad3e3"
import script from "./TaxStatus.vue?vue&type=script&lang=js"
export * from "./TaxStatus.vue?vue&type=script&lang=js"

import "./TaxStatus.vue?vue&type=style&index=0&id=22fad3e3&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/common/customs/TaxStatus.vue'],['render',render],['__file',"TaxStatus.vue"]])

export default __exports__